import React, { useState, useEffect } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";

export default function PrivateRoute({ children, role, ...rest }) {
  const { user, profile, loading } = useAuth();
  const location = useLocation();
  const [profileCheckTimeout, setProfileCheckTimeout] = useState(false);

  // FIX: Add timeout to prevent infinite loading when profile is stuck
  useEffect(() => {
    if (!loading && user && !profile && role) {
      const timeout = setTimeout(() => {
        setProfileCheckTimeout(true);
      }, 3000); // Wait 3 seconds for profile to load
      return () => clearTimeout(timeout);
    } else {
      setProfileCheckTimeout(false);
    }
  }, [loading, user, profile, role]);

  // Show loading state - don't redirect during loading
  if (loading) {
    return <div style={{ padding: 24, textAlign: 'center' }}>Loading...</div>;
  }
  
  // If not authenticated, redirect to login with intended destination
  if (!user) {
    return <Redirect to={{ pathname: "/login", state: { from: location.pathname + location.search } }} />;
  }
  
  // Check role requirement
  // FIX: Only redirect if we're sure the profile doesn't have the role
  // Don't redirect if profile is still loading or undefined (might be temporary)
  if (role) {
    // If profile exists but doesn't have the required role, redirect
    if (profile && profile.role !== role) {
      // Special handling: customers should be redirected to /tracking, admins/sales to their respective dashboards
      if (profile.role === "customer" && role !== "customer") {
        return <Redirect to="/tracking" />;
      } else if (profile.role !== "customer" && role === "customer") {
        return <Redirect to={{ pathname: "/login", state: { from: location.pathname + location.search } }} />;
      }
      return <Redirect to={{ pathname: "/login", state: { from: location.pathname + location.search } }} />;
    }
    // If profile is undefined/null but user exists, wait a bit (might be loading)
    // Don't immediately redirect - this prevents redirect loops
    if (!profile) {
      // If timeout reached, redirect to prevent infinite loading
      if (profileCheckTimeout) {
        console.warn("Profile loading timeout, redirecting to login");
        return <Redirect to={{ pathname: "/login", state: { from: location.pathname + location.search } }} />;
      }
      // Give it a moment - profile might be loading
      return <div style={{ padding: 24, textAlign: 'center' }}>Loading profile...</div>;
    }
  }

  return <Route {...rest}>{children}</Route>;
}


